<!--
 * @Author: liangchenglong 1163910414@qq.com
 * @Date: 2023-04-28 09:55:54
 * @LastEditors: liangchenglong 1163910414@qq.com
 * @LastEditTime: 2023-05-22 11:22:11
 * @FilePath: \potatocloud\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <div v-if ="$store.state.inUserCenter">
      <UserHeader></UserHeader>
        <div id="app-content">
          <router-view/>
        </div>
      <UserFooter></UserFooter>
    </div>
    <div v-else>
      <Header v-if="!$store.state.inPersonalCenter"></Header>
      <PersonalCenterHeader v-else></PersonalCenterHeader>
      <div id="app-content">
        <PersonalCenterNav v-if="$store.state.inPersonalCenter"></PersonalCenterNav>
        <router-view/>
      </div>
      <!-- 部分路由不应该包含这个Footer -->
      <Footer v-if="!$store.state.inPersonalCenter"></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header/Header';
import UserHeader from '@/components/header/UserHeader';
import PersonalCenterHeader from '@/components/personalCenterComponents/PersonalCenterHeader';
import PersonalCenterNav from '@/components/personalCenterComponents/PersonalCenterNav';
import Footer from '@/components/footer/Footer';
import UserFooter from '@/components/footer/UserFooter';
export default {
  name: 'App',
  data () {
    return {};
  },
  components: {
    Header,
    UserHeader,
    PersonalCenterHeader,
    PersonalCenterNav,
    Footer,
    UserFooter
  },
};
</script>
<style>
html{
  scroll-behavior: smooth;
}
html body{
  font-family: Microsoft YaHei-Regular;
}
html,html body,#app,#app>div {
  height: 100%;
}
#app-content {
  width: 100%;
  display: flex;
  min-height: 100%;
  /* padding-bottom: 200px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue